import { render, staticRenderFns } from "./createContainer.vue?vue&type=template&id=268465e6&scoped=true&lang=true&"
import script from "./createContainer.vue?vue&type=script&lang=js&"
export * from "./createContainer.vue?vue&type=script&lang=js&"
import style0 from "./createContainer.vue?vue&type=style&index=0&id=268465e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268465e6",
  null
  
)

export default component.exports